import { TEACHERS } from "../../lib/teachers";

const TeacherCard = ({ t }) => (
  <article className="rounded-2xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)] grid sm:grid-cols-[180px_1fr]" data-testid={`teacher-${t.id}`}>
    <div className="relative aspect-[4/5] sm:aspect-auto bg-black">
      <img src={t.photo} alt={`${t.name} — ${t.title}`} className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" />
      <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/90 to-transparent text-[10px] uppercase tracking-widest text-[color:var(--accent)]">{t.course}</div>
    </div>
    <div className="p-5 space-y-3">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--text-muted)]">{t.badge}</div>
        <h3 className="font-display text-3xl leading-none mt-1">{t.name}</h3>
        <div className="text-xs text-[color:var(--accent)]">{t.title}</div>
      </div>
      <p className="text-xs text-[color:var(--text-muted)] leading-relaxed">{t.bio}</p>
      <ul className="grid grid-cols-1 gap-1 text-xs">
        {t.highlights.map(h => <li key={h} className="flex items-start gap-2"><span className="mt-1.5 w-1 h-1 rounded-full bg-[color:var(--accent)] shrink-0" />{h}</li>)}
      </ul>
      <div className="flex flex-wrap gap-1.5">
        {t.values.map(v => <span key={v} className="px-2 py-0.5 rounded-full border border-[color:var(--border)] text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">{v}</span>)}
      </div>
    </div>
  </article>
);

export const TeachersSection = () => (
  <section className="space-y-6" data-testid="teachers-section">
    <div>
      <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-2">Les profs</div>
      <h2 className="font-display text-4xl sm:text-5xl leading-none">Quatre artistes, des vrais.</h2>
      <p className="text-sm text-[color:var(--text-muted)] mt-2 max-w-2xl">Champions, pionniers du hip-hop lyonnais, artiste plasticienne : ceux qui t'accompagnent cette saison vivent leur discipline au plus haut niveau.</p>
    </div>
    <div className="grid lg:grid-cols-2 gap-5 stagger">
      {TEACHERS.map(t => <TeacherCard key={t.id} t={t} />)}
    </div>
  </section>
);
